import { Link } from "react-router-dom";
import type { Film } from "@/types/content";

interface FilmCardProps {
  film: Film;
  compact?: boolean;
}

export default function FilmCard({ film, compact = false }: FilmCardProps) {
  return (
    <article className="group">
      <Link to={`/detail/${film.id}`} className="block cursor-pointer">
        <div className="relative w-full overflow-hidden rounded-lg border border-background-200 bg-background-200">
          <div className="aspect-[2/3] w-full">
            <img
              src={film.cover}
              alt={`${film.title} 影片封面`}
              title={`${film.title} - 三级片电影详情介绍`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
            />
          </div>
          <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-primary-950/80 via-primary-950/20 to-transparent" />
          <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-primary-950/75 px-2 py-1 text-[11px] font-medium text-secondary-300">
            <i className="ri-star-fill text-[10px] text-accent-400" />
            {film.rating.toFixed(1)}
          </span>
          <span className="absolute bottom-2 left-2 rounded-md bg-background-50/90 px-2 py-0.5 text-[11px] text-foreground-700">
            {film.region}
          </span>
          <span className="absolute bottom-2 right-2 text-[11px] text-background-100/85">
            {film.year}
          </span>
        </div>
        <h3 className="mt-3 line-clamp-2 text-sm font-medium leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-[15px]">
          {film.title}
        </h3>
        {!compact && (
          <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">
            {film.cast.join(" · ")}
          </p>
        )}
      </Link>
    </article>
  );
}